import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import template from "./my-site-share.html";

export class MySiteShare extends PolymerElement {
    static get template() {
        let htmlElement = document.createElement("TEMPLATE");
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get is() {
        return "my-site-share";
    }

    static get properties() {
        return {
            _photoUrl: {
                type: String,
                observer: "_handlePhoto"
            },
            _storeName: {
                string: String,
                value: ""
            },
            _storeDescription: {
                type: String,
                value: ""
            }
        };
    }

    ready() {
        super.ready();
    }


    showModal(message) {
        // Show modal and set message
        const modal = this.shadowRoot.querySelector('.modalCopy');
        const modalMessage = this.shadowRoot.querySelector('.modal-content-copy');
        modalMessage.textContent = message;
        modal.style.display = 'block';
    }
    hideModal() {
        // Hide modal
        const modalCopy = this.shadowRoot.querySelector('.modalCopy');
        modalCopy.style.display = 'none';
    }
    copyToClipboard() {
        const siteUrl = window.location.href;
        navigator.clipboard
            .writeText(siteUrl)
            .then(() => {
                console.log("fullUrl", siteUrl);
            })
            .catch((error) => {
                console.error("Failed to copy url", error);
            });
        this.showModal('Url copied to clipboard..');
        setTimeout(()=>{
            this.hideModal();
        },1000)
    }
    shareOnFacebook() {
        const productUrl = window.location.href;
        window.open(
            "https://www.facebook.com/sharer/sharer.php?u=" +
            encodeURIComponent(productUrl)
        );
    }
    shareOnInstagram() {
        const productUrl = window.location.href;
        window.open(
            "https://www.instagram.com/?url=" + encodeURIComponent(productUrl)
        );
    }
    shareOnSnapchat() {
        const productUrl = window.location.href;
        window.open("https://www.snapchat.com/?original_referrer=www.google.com'" + encodeURIComponent(productUrl));
    }
    shareOnGmail() {
        const productUrl = window.location.href;
        // Construct email URL
        const emailSubject = 'Check out this product!';
        const emailBody = `I found this amazing product: ${productUrl}`;
        const emailUrl = `mailto:?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;
        // Open default email client
        window.location.href = emailUrl;
    }

    _closeModal() {
        const modal = this.shadowRoot.querySelector(".modal");
        modal.style.display = "none";
    }
}

window.customElements.define(MySiteShare.is, MySiteShare);
